export const toMinutes = (t: string): number => {
  const [h, m] = (t || '0:0').split(':').map((n) => parseInt(n, 10) || 0);
  return h * 60 + m;
};

export const fmtTime = (t: string): string => {
  const mins = toMinutes(t);
  const h24 = Math.floor(mins / 60);
  const mm = mins % 60;
  const suffix = h24 < 12 ? 'AM' : 'PM';
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${h12}:${mm.toString().padStart(2, '0')} ${suffix}`;
};

export const slotFloor = (t: string, rangeStartMin: number): number => {
  const mins = Math.max(rangeStartMin, toMinutes(t));
  return Math.floor((mins - rangeStartMin) / 30);
};

export const slotCeil = (t: string, rangeStartMin: number): number => {
  const mins = Math.max(rangeStartMin, toMinutes(t));
  return Math.ceil((mins - rangeStartMin) / 30);
};

